import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../gn';

@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn:GN) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad NotificationsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts